<template>
    <vx-card class="mt-4" title="Data" v-if="hasParent && !hide">

        <slot></slot>

        <div v-if="!hideBody">
            <slot name="pages"
                    :pages="pages">
                <div class="vue-qz-tray--input--data">
                       <p v-for="(page, index) in pages">{{page}}</p>
                </div>
            </slot>
        </div>


    </vx-card>
</template>

<script>
    import QzMixin from './qz-mixin';
    import VueQzTrayInputIframe from './vue-qz-tray-input-iframe.vue';

    export default {
        name: 'VueQzTrayInput',

        label: 'input',

        mixins: [QzMixin],

        components: {
            VueQzTrayInputIframe
        },

        props: {
            pages: Array
        },

        computed: {
            type: function() {
                return (this.qzOptions.type && ['raw'].indexOf(this.qzOptions.type) < 0) ? 'raw' : this.qzOptions.type;
            }
        },

        watch: {
            pages: {
                immediate: true,
                handler: function(newPages) {
                    this.$emitLocalAndRoot('pages-changed', newPages);
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .vue-qz-tray--with-style .vue-qz-tray--input {
        .vue-qz-tray--input--header--wrapper {
            display: block;
            position: relative;

            width: 100%;

            margin: 0;
            padding: 15px 0;

            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;

            .vue-qz-tray--input--label--wrapper, .vue-qz-tray--input--type--wrapper {
                display: inline-block;
                position: relative;

                margin: 0 5px;
                padding: 0;

                .vue-qz-tray--input--label, .vue-qz-tray--input--type {
                    display: inline-block;
                    position: relative;

                    margin: 0;
                    padding: 0;
                }

                &:first-child {
                    margin-left: 0;
                }

                &:last-child {
                    margin-right: 0;
                }
            }

            .vue-qz-tray--input--type--wrapper {
                float: right;
            }
        }

        .vue-qz-tray--input--data--wrapper {
            display: block;
            position: relative;

            width: 100%;

            margin: 0;
            padding: 15px 0;

            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;

            .vue-qz-tray--input--data {
                display: block;
                position: relative;

                width: 100%;

                margin: 0;
                padding: 0;

                zoom: 0.5;

                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
            }
        }
    }
</style>
